import React from 'react';
import { X, Plus } from 'lucide-react';

const MultiImageUpload = ({ images, onChange }) => {
    const handleFileChange = (e) => {
        const files = e.target.files;
        if (files) {
            // Convert FileList to Array and combine with existing files
            const newFiles = Array.from(files);
            onChange([...images, ...newFiles]);
        }
    };

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-3 gap-4">
                {images.map((image, index) => (
                    <div key={index} className="relative group">
                        <img
                            src={image instanceof File ? URL.createObjectURL(image) : image}
                            alt={`Preview ${index + 1}`}
                            className="w-full h-24 object-cover rounded-lg"
                        />
                        <button
                            type="button"
                            onClick={() => {
                                const newImages = [...images];
                                newImages.splice(index, 1);
                                onChange(newImages);
                            }}
                            className="absolute top-2 right-2 p-1 bg-red-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                            <X size={16} className="text-white" />
                        </button>
                    </div>
                ))}
            </div>
            <input
                type="file"
                name="slider_images"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2.5"
            />
        </div>
    );
};

export default MultiImageUpload;